export const themes = Object.freeze({
  sportsman: "sportsman",
  sportswoman: "sportswoman",
  pro: "pro"
})
